export default __webpack_public_path__ + "media/images/formatjs_logo-61a8d183.svg";